import CryptoJS from 'crypto-js';

const secretKey = 'my-custom-secret-key:1af0addcce4b56f753ed10c285667ad031bae57af19747f576b05312b8cf85be';

/**
 * Lê user do localStorage de forma segura.
 * Lida com ambos os formatos:
 *   - Plain JSON (formato novo da migração auth)
 *   - CryptoJS encrypted (formato legado)
 * Retorna o objeto parsed ou null se inválido/ausente.
 */
export function getStoredUser() {
    try {
        const raw = localStorage.getItem('user');
        if (!raw) return null;

        // Tentar plain JSON primeiro (formato novo)
        try {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === 'object') return parsed;
        } catch (_) { /* não é JSON, tentar decrypt */ }

        // Tentar CryptoJS decrypt (formato legado: começa com "U2FsdGVkX1")
        if (typeof raw === 'string' && raw.startsWith('U2FsdGVkX1')) {
            const decrypted = CryptoJS.AES.decrypt(raw, secretKey).toString(CryptoJS.enc.Utf8);
            if (decrypted) {
                const parsed = JSON.parse(decrypted);
                // Migrar para formato novo automaticamente
                localStorage.setItem('user', JSON.stringify(parsed));
                return parsed;
            }
        }

        // Dado corrompido → limpar
        localStorage.removeItem('user');
        return null;
    } catch (_) {
        localStorage.removeItem('user');
        return null;
    }
}

/**
 * Lê user como string JSON do localStorage.
 * Para componentes que fazem JSON.parse() separadamente.
 */
export function getStoredUserString() {
    const user = getStoredUser();
    return user ? JSON.stringify(user) : null;
}
